<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <ValidationObserver ref="form_datos">
          <v-card class="mx-auto" :loading="loading">
            <v-card-text class="text--primary px-8">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Nombre" rules="required">
                    <v-text-field
                      v-model="objDatos.nombres"
                      label="Nombre"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Apellidos" rules="required">
                    <v-text-field
                      v-model="objDatos.apellidos"
                      label="Apellidos"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider
                    name="Tipo de identificación"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="objDatos.tipoidentificacion"
                      :items="tiposIdentificacion"
                      item-text="tipo"
                      item-value="id"
                      label="Tipo de identificación"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider
                    name="# Identificación"
                    rules="required|integer"
                  >
                    <v-text-field
                      type="number"
                      v-model="objDatos.identificacion"
                      label="# Identificación"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Teléfono" rules="required|integer">
                    <v-text-field
                      v-model="objDatos.telefono"
                      label="Teléfono"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Ciudad" rules="required">
                    <v-text-field
                      v-model="objDatos.ciudad"
                      label="Ciudad"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Dirección" rules="required">
                    <v-text-field
                      v-model="objDatos.direccion"
                      label="Dirección"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col v-if="this.id" cols="12" sm="6" md="4">
                  <v-select
                    v-model="objDatos.estado"
                    :items="state"
                    item-text="name"
                    item-value="val"
                    label="Estado"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>

        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModAdd",
  data: () => ({
    objDatos: {},
    dialog: true,
    loading: true,
    state: [
      { name: "Activo", val: true },
      { name: "Inactivo", val: false },
    ],
    tiposIdentificacion: [],
  }),
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
  },
  computed: {
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
  },
  created() {
    this.getData();
    this.tipoIdentificacion();
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection("clientes").doc(this.id).get();
          this.objDatos = datos.data();
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async save() {
      try {
        const validar = await this.$refs.form_datos.validate();
        if (!validar) return false;
        this.loading = true;
        Object.entries(this.objDatos).forEach((el) => {
          if (typeof el[1] === "string" && el[0] != "tokenPush") {
            this.objDatos[el[0]] = el[1].toUpperCase().trim();
          }
        });
        if (!this.id) {
          // Guardar
          this.objDatos.creado = Date.now();
          this.objDatos.estado = true;
          await db.collection("clientes").add(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } else {
          // update
          this.objDatos.modificacion = Date.now();
          await db.collection("clientes").doc(this.id).update(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async tipoIdentificacion() {
      this.tiposIdentificacion = [];
      try {
        const tipoIdentificacion = await db
          .collection("tiposidentificacion")
          .get();
        this.tiposIdentificacion = tipoIdentificacion.docs.map((e) => ({
          id: e.id,
          ...e.data(),
        }));
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
